import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Rosario',
  text: 'Cerré 3 propiedades en el primer mes. El Kit de Reunión me dio la confianza que me faltaba.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'Córdoba',
  text: 'Tengo 7 propiedades y trabajo 3 horas por día. El Autopilot hace posible escalar sin volverse loco.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Mendoza',
  text: 'Saber responder "tu comisión es alta" con datos reales cambia todo. El Kit de Objeciones es el mejor bono.'
}, {
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Neuquén',
  text: 'Nunca tuve un departamento propio y hoy gestiono 4. El Tomo 1 me hizo entender que no necesitaba capital.'
}];
export function MoreTestimonials() {
  return <section className="py-20 bg-surface" data-id="element-171">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-172">
        <div className="text-center mb-12" data-id="element-173">
          <h2 className="text-3xl font-bold text-gray-900 flex items-center justify-center gap-3" data-id="element-174">
            <Heart className="w-8 h-8 text-accent-pink fill-accent-pink" data-id="element-175" />
            MÁS MANAGERS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-176">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-177">
              <div className="flex gap-1 mb-4" data-id="element-178">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-179" />)}
              </div>
              <p className="text-gray-700 italic mb-6 text-sm leading-relaxed flex-grow" data-id="element-180">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-50" data-id="element-181">
                <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center font-bold text-gray-600 text-sm shrink-0" data-id="element-182">
                  {t.initials}
                </div>
                <div data-id="element-183">
                  <div className="font-bold text-gray-900 text-sm" data-id="element-184">
                    {t.name} — 📍 {t.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}